<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-19 10:15:57
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/ModelSelectMult.vue
-->
<template>
    <div>
        <label class="block text-white text-sm mb-[10px]">
            {{ t('tools.model') }}
        </label>
        <el-select  
            v-model="models"
            class="w-full h-14 bg-tool-default-black rounded-[10px] border  border-white/[0.06] hover:border-white/30"
            popper-class="select-popper"
            :fit-input-width="true"
            :show-arrow="false"
            :placeholder="t('tools.describeModel')"
            :aria-label="t('tools.model')"
            multiple
        >
            <template #label>
                <div class="flex items-center gap-2">
                    <img
                        v-if="currentModel?.thumbnail"
                        :src="currentModel?.thumbnail"
                        alt="icon"
                        class="w-8 h-8 object-cover"
                    />
                    <div class="text-sm font-medium flex flex-col gap-0.5">
                        <span
                            class="text-f-text text-white flex items-center gap-1 text-sm font-semibold"
                            >{{ currentModel?.title }}</span
                        >
                        <span class="text-not-active text-xs font-medium">{{
                            currentModel?.desc
                        }}</span>
                    </div>
                </div>
            </template>

            <el-option
                v-for="item in props.model_list"
                :key="item.model_key"
                :label="item.model_key"
                :value="item.model_key"
            >
                <div
                    class="flex items-center  group gap-2 h-full overflow-hidden whitespace-normal"
                >
                    <img
                        :src="
                            isChooseModel(item?.model_key)
                                ? checkedIcon
                                : notCheckedIcon
                        "
                        alt="checked"
                        class="w-5 h-5 object-cover"
                    />
                    <img
                        v-if="item?.thumbnail"
                        :src="item?.thumbnail"
                        alt="icon"
                        class="w-8 h-8 object-cover"
                    />

                    <div class="text-sm font-medium flex flex-col gap-0.5">
                        <span
                            class="text-white flex items-center gap-1 text-sm font-semibold group-hover:opacity-60 transition-all duration-300"
                            >{{ item?.title }}</span
                        >
                        <span
                            class="text-not-active text-xs font-medium line-clamp-1 group-hover:opacity-60 transition-all duration-300"
                            >{{ item?.desc }}</span
                        >
                    </div>
                </div>
            </el-option>
        </el-select>
        <div class="flex items-center gap-[6px] flex-wrap justify-start mt-2">
            <span
                v-for="item in getModelListByModels()"
                :key="item.model_key"
                class="flex gap-[6px] items-center justify-center rounded-3xl bg-switch-inactive-dot text-sub-title text-[10px] px-[10px] py-1"
            >
                <span>{{ item.title }}</span>
                <el-icon
                    v-if="models.length > 1"
                    class="cursor-pointer hover:text-text-active hover:scale-110 transition-all duration-300"
                    @click="removeModelItem(item.model_key)"
                    ><Close
                /></el-icon>
            </span>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useI18n } from '~/composables/useI18n'
import { noticeMessagePopup } from '~/utils/common'

const props = withDefaults(
    defineProps<{
        type: string
        model_list: Array<any>
    }>(),
    {
        type: 'text_to_image',
        model_list: () => [],
    }
)
const { t, locale } = useI18n()

// 最大选择限制
const MAX_SELECT_LIMIT = 4

const checkedIcon =
    'https://static.weryai.com/growth/image/4ebae3f3edb8f4f52281d018c7816648.webp'
const notCheckedIcon =
    'https://static.weryai.com/growth/image/bd6f71cdf35a64773b80d7a5a9930322.webp'

const models = defineModel('models', {
    type: Array<string>,
    default: () => [],
})

// 保存上一次的模型选择，用于超出限制时恢复
const previousModels = ref<string[]>([])

onMounted(() => {
    // 初始化保存当前模型选择
    previousModels.value = [...models.value]
})

// 处理模型选择变化事件
const handleModelChange = (value: string[]) => {
    if (value.length > MAX_SELECT_LIMIT) {
        // 超出限制，恢复之前的选择
        models.value = [...previousModels.value]
        // 显示提示信息

        noticeMessagePopup(
            t('batchTools.selectModelLimitExceeded', {
                maxCount: MAX_SELECT_LIMIT,
            }),
            t('common.tip'),
            'warning',
            5000,
            ''
        )
    } else {
        // 更新保存的选择
        previousModels.value = [...value]
    }
}

const currentModel = computed(() => {
    // 只展示选中的第一项的数据
    if (!models.value || models.value.length === 0) {
        return null
    }
    return (
        props.model_list.find(item => item.model_key === models.value[0]) ||
        null
    )
})

//  is choose model
const isChooseModel = (model_key: string) => {
    return models.value?.includes(model_key)
}

//  remove model item
const removeModelItem = (modelKey: string) => {
    // 从 models 数组中移除对应的 model_key
    const newModels = models.value.filter(key => key !== modelKey)

    // 更新 models，创建新数组以触发响应式更新
    models.value = [...newModels]
}

//  match model_list with models
const getModelListByModels = () => {
    return props.model_list.filter(item =>
        models.value.includes(item.model_key)
    )
}
</script>
<style scoped lang="less">
:deep(.el-select__wrapper) {
    height: 100%;
    background-color: transparent;
    border: none;
    box-shadow: none;
    &:hover {
        border: none;
        box-shadow: none;
    }
    &:focus-visible {
        border: none;
    }
}

:deep(.el-tag) {
    background-color: transparent !important;
}
:deep(.el-tag__close) {
    display: none;
}
:deep(.el-select__selected-item) {
    &:nth-child(n + 2) {
        display: none !important;
    }
}
</style>
